export const en = {
  'blocks.title': 'Blocks',
  'blocks.add': 'Add block',
  'blocks.addBelow': 'Add a block',
  'blocks.emptyHint': 'Open the library and pick a block to start this page.',
  'blocks.actions': 'Block actions',
  'blocks.drag': 'Drag to move {name}',
  'blocks.duplicate': 'Duplicate',
  'blocks.saveTemplate': 'Save as template',
  'blocks.saveTemplateTitle': 'Save this block as a template',
  'blocks.saveTemplateDescription': 'The template appears under Saved in the library. Inserting it adds a copy; later changes to the copy do not touch the template.',
  'blocks.deleteTitle': 'Remove this block?',
  'blocks.deleteDescription': 'It disappears from the draft now and from the live site when you publish. To keep it for later, hide it instead.',
  'blocks.tab.content': 'Content',
  'blocks.tab.style': 'Style',
  'blocks.library.title': 'Add a block',
  'blocks.library.description': 'Every block is painted in your brand colours. Pick one to insert it below the selected block.',
  'blocks.library.categories': 'Block categories',
  'blocks.library.search': 'Search blocks',
  'blocks.library.noMatch': 'No block matches your search.',
  'blocks.library.savedEmpty': 'No saved templates yet',
  'blocks.library.savedEmptyHint': 'Choose “Save as template” on any block to reuse it on other pages.',
  'blocks.library.name': 'Template name',
  'blocks.library.rename': 'Rename template',
  'blocks.library.deleteSaved': 'Delete template',
  'blocks.library.full': 'The library holds 100 templates. Delete one to save another.',
  'blocks.category.all': 'All blocks',
  'blocks.category.intro': 'Intro',
  'blocks.category.content': 'Text and content',
  'blocks.category.media': 'Media',
  'blocks.category.gym': 'Your gym',
  'blocks.category.action': 'Calls to action',
  'blocks.category.layout': 'Layout',
  'blocks.category.advanced': 'Advanced',
  'blocks.category.saved': 'Saved',
  'blocks.style.look': 'Look',
  'blocks.style.scheme': 'Colours',
  'blocks.style.schemeHint': 'Each scheme repaints the block from your brand colours.',
  'blocks.style.spacing': 'Space above and below',
  'blocks.style.width': 'Width',
  'blocks.style.align': 'Alignment',
  'blocks.style.hideOn': 'Hide on',
  'blocks.style.anchor': 'Link anchor',
  'blocks.style.anchorHint': 'Optional. Lets a button link straight to this block, like /#offers.',
  'blocks.style.anchorInvalid': 'Use lowercase letters, digits and dashes.',
  'blocks.scheme.default': 'Page',
  'blocks.scheme.muted': 'Soft',
  'blocks.scheme.inverse': 'Inverted',
  'blocks.scheme.brand': 'Brand',
  'blocks.scheme.dark': 'Dark',
  'blocks.scheme.light': 'Light',
  'blocks.spacing.none': 'None',
  'blocks.spacing.sm': 'S',
  'blocks.spacing.md': 'M',
  'blocks.spacing.lg': 'L',
  'blocks.spacing.xl': 'XL',
  'blocks.width.narrow': 'Narrow',
  'blocks.width.normal': 'Normal',
  'blocks.width.wide': 'Wide',
  'blocks.width.full': 'Full width',
  'blocks.align.start': 'Left',
  'blocks.align.center': 'Centre',
  'blocks.device.mobile': 'Phones',
  'blocks.device.desktop': 'Computers',
  'blocks.variant.default': 'Standard',
  'blocks.variant.cover': 'Cover photo',
  'blocks.variant.centered': 'Centred',
  'blocks.variant.split': 'Side by side',
  'blocks.variant.minimal': 'Minimal',
  'blocks.variant.plain': 'Plain',
  'blocks.variant.image': 'With photo',
  'blocks.variant.image-right': 'Photo on the right',
  'blocks.variant.image-left': 'Photo on the left',
  'blocks.variant.stacked': 'Stacked',
  'blocks.variant.cards': 'Cards',
  'blocks.variant.icons': 'Icons',
  'blocks.variant.list': 'List',
  'blocks.variant.row': 'Row',
  'blocks.variant.vertical': 'Vertical',
  'blocks.variant.alternating': 'Alternating',
  'blocks.variant.numbered': 'Numbered',
  'blocks.variant.large': 'Large',
  'blocks.variant.card': 'Card',
  'blocks.variant.grid': 'Grid',
  'blocks.variant.carousel': 'Carousel',
  'blocks.variant.masonry': 'Masonry',
  'blocks.variant.contained': 'In the page',
  'blocks.variant.full': 'Edge to edge',
  'blocks.variant.table': 'Table',
  'blocks.variant.week': 'Week',
  'blocks.variant.compact': 'Compact',
  'blocks.variant.banner': 'Banner',
  'blocks.variant.headline': 'Headline',
  'blocks.option.narrow': 'Narrow',
  'blocks.option.wide': 'Wide',
  'blocks.option.list': 'List',
  'blocks.option.cards': 'Cards',
  'blocks.option.primary': 'Filled',
  'blocks.option.outline': 'Outline',
  'blocks.option.sm': 'Small',
  'blocks.option.md': 'Medium',
  'blocks.option.lg': 'Large',
  'blocks.option.xl': 'Extra large',
  'blocks.option.line': 'Line',
  'blocks.option.dots': 'Dots',
  'blocks.option.accent': 'Brand bar',
  'blocks.PAGE_HEADER.label': 'Page header',
  'blocks.PAGE_HEADER.description': 'The title at the top of an inner page, with an optional photo behind it.',
  'blocks.MEDIA_TEXT.label': 'Photo and text',
  'blocks.MEDIA_TEXT.description': 'A photo or video beside a heading, formatted text and a button.',
  'blocks.COLUMNS.label': 'Columns',
  'blocks.COLUMNS.description': 'Two to four columns, each with an icon or photo, a title, text and a link.',
  'blocks.STATS.label': 'Numbers',
  'blocks.STATS.description': 'Big figures that tell your story at a glance.',
  'blocks.TIMELINE.label': 'Timeline',
  'blocks.TIMELINE.description': 'Your history, year by year.',
  'blocks.STEPS.label': 'Steps',
  'blocks.STEPS.description': 'A numbered how-it-works, such as how to join.',
  'blocks.QUOTE.label': 'Quote',
  'blocks.QUOTE.description': 'One big quotation with its author.',
  'blocks.IMAGE.label': 'Photo',
  'blocks.IMAGE.description': 'One photo, in the page or edge to edge, with a caption.',
  'blocks.VIDEO.label': 'Video',
  'blocks.VIDEO.description': 'A YouTube or Vimeo video, or a video file that can play silently on a loop.',
  'blocks.LOGOS.label': 'Logos',
  'blocks.LOGOS.description': 'A strip of partner or brand logos.',
  'blocks.SCHEDULE.label': 'Timetable',
  'blocks.SCHEDULE.description': 'The classes of the coming days, taken from your schedule.',
  'blocks.CAREERS.label': 'Careers',
  'blocks.CAREERS.description': 'The open jobs from Recruiting, each with an application form that takes a CV.',
  'blocks.field.privacySlug': 'Privacy page address',
  'blocks.field.privacySlugHint': 'The content page the consent line links to, as /p/ plus this address.',
  'blocks.preset.careers.cards': 'Careers in two columns',
  'blocks.OFFER.label': 'Offer',
  'blocks.OFFER.description': 'The campaign running now, with its discount and dates.',
  'blocks.RECOGNITION.label': 'Team awards',
  'blocks.RECOGNITION.description': "The awards you marked public, such as trainer of the month. They also appear on the trainer's own page.",
  'blocks.preset.recognition.list': 'Awards as a list',
  'blocks.LOCATIONS.label': 'Branches',
  'blocks.LOCATIONS.description': 'Every branch with its address and phone.',
  'blocks.HOURS.label': 'Opening hours',
  'blocks.HOURS.description': 'The week, day by day, from the gym settings.',
  'blocks.SOCIAL.label': 'Social links',
  'blocks.SOCIAL.description': 'Your social profiles as big buttons.',
  'blocks.BUTTONS.label': 'Buttons',
  'blocks.BUTTONS.description': 'One to four buttons in a row.',
  'blocks.SPACER.label': 'Space',
  'blocks.SPACER.description': 'Empty room between two blocks.',
  'blocks.DIVIDER.label': 'Divider',
  'blocks.DIVIDER.description': 'A line between two blocks.',
  'blocks.EMBED.label': 'Embed',
  'blocks.EMBED.description': 'A player or map from YouTube, Vimeo, Google Maps, Instagram or Facebook.',
  'blocks.preset.hero.centered': 'Hero, centred with logo',
  'blocks.preset.hero.split': 'Hero, side by side',
  'blocks.preset.hero.minimal': 'Hero, text only',
  'blocks.preset.pageHeader.image': 'Page header with photo',
  'blocks.preset.about.stacked': 'About, photo below',
  'blocks.preset.mediaText.right': 'Photo on the right',
  'blocks.preset.columns.cards': 'Columns as cards',
  'blocks.preset.facilities.list': 'Facilities as a list',
  'blocks.preset.stats.dark': 'Numbers on dark',
  'blocks.preset.timeline.alternating': 'Timeline, alternating',
  'blocks.preset.steps.cards': 'Steps as cards',
  'blocks.preset.quote.card': 'Quote in a card',
  'blocks.preset.testimonials.carousel': 'Testimonials carousel',
  'blocks.preset.image.full': 'Photo edge to edge',
  'blocks.preset.gallery.masonry': 'Gallery, masonry',
  'blocks.preset.gallery.carousel': 'Gallery carousel',
  'blocks.preset.video.full': 'Background video',
  'blocks.preset.plans.table': 'Price table',
  'blocks.preset.classes.list': 'Classes as a list',
  'blocks.preset.schedule.list': 'Timetable as a list',
  'blocks.preset.trainers.carousel': 'Trainers carousel',
  'blocks.preset.trainers.compact': 'Team portraits',
  'blocks.preset.offer.card': 'Offer card',
  'blocks.preset.social.headline': 'Big social headline',
  'blocks.preset.cta.split': 'Call to action, split',
  'blocks.preset.cta.minimal': 'Call to action, minimal',
  'blocks.field.eyebrow': 'Small line above the title',
  'blocks.field.eyebrowHint': 'Optional, e.g. the gym name or city.',
  'blocks.field.showLogo': 'Show the logo',
  'blocks.field.showLogoHint': 'Uses the logo from Branding.',
  'blocks.field.pageHeaderImageHint': 'Shown when the look is “With photo”.',
  'blocks.field.video': 'Video link',
  'blocks.field.videoHint': 'A YouTube or Vimeo link, or an https link to an MP4 file.',
  'blocks.field.columns': 'Columns',
  'blocks.field.items': 'Items',
  'blocks.field.column': 'Column {n}',
  'blocks.field.addColumn': 'Add column',
  'blocks.field.noItems': 'Nothing added yet.',
  'blocks.field.icon': 'Icon',
  'blocks.field.noIcon': 'No icon',
  'blocks.field.number': 'Number {n}',
  'blocks.field.addNumber': 'Add number',
  'blocks.field.value': 'Figure',
  'blocks.field.valueHint': 'Up to 24 characters, e.g. 24/7 or 2000 m².',
  'blocks.field.milestone': 'Milestone {n}',
  'blocks.field.addMilestone': 'Add milestone',
  'blocks.field.when': 'When',
  'blocks.field.whenHint': 'A year or a short date, e.g. 1965.',
  'blocks.field.stepItem': 'Step {n}',
  'blocks.field.addStep': 'Add step',
  'blocks.field.role': 'Role',
  'blocks.field.photo': 'Photo',
  'blocks.field.alt': 'Description for screen readers',
  'blocks.field.altHint': 'What the photo shows, for visitors who cannot see it.',
  'blocks.field.caption': 'Caption',
  'blocks.field.poster': 'Still image before the video plays',
  'blocks.field.autoplay': 'Play on screen',
  'blocks.field.autoplayHint': 'Plays muted while visitors can see it and pauses when they scroll past. Works for a video file, YouTube and Vimeo.',
  'blocks.field.logo': 'Logo {n}',
  'blocks.field.addLogo': 'Add logo',
  'blocks.field.name': 'Name',
  'blocks.field.days': 'Days to show',
  'blocks.field.specialties': 'Only trainers with these specialities',
  'blocks.field.specialtiesHint': 'Leave empty to show every trainer on the website.',
  'blocks.field.noSpecialties': 'No specialities yet.',
  'blocks.field.limit': 'At most',
  'blocks.field.limitHint': 'Optional. Leave empty to show them all.',
  'blocks.field.offerFallbackHint': 'Used only when no campaign is running.',
  'blocks.field.showWhenNone': 'Show when no campaign is running',
  'blocks.field.showWhenNoneHint': 'Off: the block disappears between campaigns.',
  'blocks.field.note': 'Note',
  'blocks.field.hoursHint': 'The hours themselves come from Settings → Opening hours.',
  'blocks.field.buttons': 'Buttons',
  'blocks.field.buttonItem': 'Button {n}',
  'blocks.field.addButton': 'Add button',
  'blocks.field.buttonStyle': 'Style',
  'blocks.field.size': 'Size',
  'blocks.field.dividerStyle': 'Style',
  'blocks.field.embedUrl': 'Embed link',
  'blocks.field.embedUrlHint': 'The “embed” link from YouTube, Vimeo, Google Maps, Instagram or Facebook. Other sites are refused.',
  'blocks.field.aspect': 'Shape',
  'blocks.field.embedTitle': 'Title for screen readers',
  'blocks.field.embedTitleHint': 'What the embed shows, e.g. “Map to the gym”.',
  'website.pages.drag': 'Drag to move the page {name}',
  'website.pages.untitled': 'Untitled page',
  'website.pages.addTitle': 'Add a page',
  'website.pages.addDescription': 'Give it a title and start from a template. You can change everything afterwards.',
  'website.pages.titleAddressHint': 'The page address is made from the title.',
  'website.pages.create': 'Create page',
  'website.pages.template': 'Start from',
  'website.pages.template.blank': 'Blank',
  'website.pages.template.blank.hint': 'An empty page.',
  'website.pages.template.landing': 'Landing page',
  'website.pages.template.landing.hint': 'Hero, numbers, prices, reviews and a call to action.',
  'website.pages.template.about': 'About',
  'website.pages.template.about.hint': 'Your story, history, team and photos.',
  'website.pages.template.pricing': 'Prices',
  'website.pages.template.pricing.hint': 'The price table, the current offer and questions.',
  'website.pages.template.contact': 'Contact',
  'website.pages.template.contact.hint': 'Contact form, opening hours, branches and a map.',
  'website.pages.template.gallery': 'Gallery',
  'website.pages.template.gallery.hint': 'Photos and a video.',
  'website.pages.addressAuto': 'Made from the title. It stays fixed once the page is published, so links to it keep working.',
  'website.pages.addressAfterSave': 'Made from the title when you save the draft.',
  'website.pages.addressLocked': 'Set by Bulk. It no longer follows the title.',
  'website.pages.addressLockedShort': 'Address set by Bulk',
  'website.pages.copyAddress': 'Copy the page link',
  'website.pages.addressCopied': 'Link copied',
  'website.pages.addressCopyFailed': 'The link could not be copied',
  'website.pages.setAddress': 'Set the address',
  'website.pages.setAddressDescription': 'Only Bulk can choose an address by hand, usually to keep a link from the old site working.',
  'website.pages.saveBeforeAddress': 'Save the draft first',
  'website.pages.addressFollowTitle': 'Follow the title again',
  'website.pages.addressSet': 'Address saved',
  'website.pages.seo': 'Search and sharing',
  'website.pages.seoTitleHint': 'Shown in the browser tab and in search results. Leave empty to use the page title.',
};

export const ka: Record<keyof typeof en, string> = {
  'blocks.title': 'ბლოკები',
  'blocks.add': 'ბლოკის დამატება',
  'blocks.addBelow': 'ბლოკის დამატება',
  'blocks.emptyHint': 'გახსენით ბიბლიოთეკა და აირჩიეთ ბლოკი, რომ ამ გვერდის აწყობა დაიწყოთ.',
  'blocks.actions': 'ბლოკის მოქმედებები',
  'blocks.drag': 'გადაათრიეთ {name}-ის გადასატანად',
  'blocks.duplicate': 'დუბლირება',
  'blocks.saveTemplate': 'შაბლონად შენახვა',
  'blocks.saveTemplateTitle': 'ამ ბლოკის შაბლონად შენახვა',
  'blocks.saveTemplateDescription': 'შაბლონი გამოჩნდება ბიბლიოთეკის „შენახულში“. ჩასმისას ემატება ასლი; ასლის შემდგომი ცვლილებები შაბლონს არ ეხება.',
  'blocks.deleteTitle': 'წავშალოთ ეს ბლოკი?',
  'blocks.deleteDescription': 'ის ახლავე ქრება მონახაზიდან, ხოლო საიტიდან — გამოქვეყნებისას. მოგვიანებისთვის შესანახად ჯობს დამალოთ.',
  'blocks.tab.content': 'შიგთავსი',
  'blocks.tab.style': 'სტილი',
  'blocks.library.title': 'ბლოკის დამატება',
  'blocks.library.description': 'ყველა ბლოკი თქვენი ბრენდის ფერებით იხატება. აირჩიეთ ბლოკი და ის მონიშნულის ქვემოთ ჩაჯდება.',
  'blocks.library.categories': 'ბლოკების კატეგორიები',
  'blocks.library.search': 'ბლოკების ძებნა',
  'blocks.library.noMatch': 'ძებნას ბლოკი არ ემთხვევა.',
  'blocks.library.savedEmpty': 'შენახული შაბლონები ჯერ არ არის',
  'blocks.library.savedEmptyHint': 'ნებისმიერ ბლოკზე აირჩიეთ „შაბლონად შენახვა“, რომ სხვა გვერდებზეც გამოიყენოთ.',
  'blocks.library.name': 'შაბლონის სახელი',
  'blocks.library.rename': 'შაბლონის გადარქმევა',
  'blocks.library.deleteSaved': 'შაბლონის წაშლა',
  'blocks.library.full': 'ბიბლიოთეკა 100 შაბლონს იტევს. ახლის შესანახად ერთი წაშალეთ.',
  'blocks.category.all': 'ყველა ბლოკი',
  'blocks.category.intro': 'შესავალი',
  'blocks.category.content': 'ტექსტი და შიგთავსი',
  'blocks.category.media': 'მედია',
  'blocks.category.gym': 'თქვენი დარბაზი',
  'blocks.category.action': 'მოწოდება მოქმედებისკენ',
  'blocks.category.layout': 'განლაგება',
  'blocks.category.advanced': 'გაფართოებული',
  'blocks.category.saved': 'შენახული',
  'blocks.style.look': 'იერსახე',
  'blocks.style.scheme': 'ფერები',
  'blocks.style.schemeHint': 'თითოეული სქემა ბლოკს თქვენი ბრენდის ფერებით ხატავს.',
  'blocks.style.spacing': 'დაშორება ზემოთ და ქვემოთ',
  'blocks.style.width': 'სიგანე',
  'blocks.style.align': 'სწორება',
  'blocks.style.hideOn': 'დამალვა',
  'blocks.style.anchor': 'ბმულის წამყვანი',
  'blocks.style.anchorHint': 'არასავალდებულო. ღილაკს პირდაპირ ამ ბლოკზე მიყვანის საშუალებას აძლევს, მაგ. /#offers.',
  'blocks.style.anchorInvalid': 'გამოიყენეთ პატარა ლათინური ასოები, ციფრები და ტირეები.',
  'blocks.scheme.default': 'გვერდი',
  'blocks.scheme.muted': 'რბილი',
  'blocks.scheme.inverse': 'შებრუნებული',
  'blocks.scheme.brand': 'ბრენდი',
  'blocks.scheme.dark': 'მუქი',
  'blocks.scheme.light': 'ღია',
  'blocks.spacing.none': 'არა',
  'blocks.spacing.sm': 'S',
  'blocks.spacing.md': 'M',
  'blocks.spacing.lg': 'L',
  'blocks.spacing.xl': 'XL',
  'blocks.width.narrow': 'ვიწრო',
  'blocks.width.normal': 'ჩვეულებრივი',
  'blocks.width.wide': 'ფართო',
  'blocks.width.full': 'მთელ სიგანეზე',
  'blocks.align.start': 'მარცხნივ',
  'blocks.align.center': 'ცენტრში',
  'blocks.device.mobile': 'ტელეფონებზე',
  'blocks.device.desktop': 'კომპიუტერებზე',
  'blocks.variant.default': 'სტანდარტული',
  'blocks.variant.cover': 'ფონური ფოტო',
  'blocks.variant.centered': 'ცენტრში',
  'blocks.variant.split': 'გვერდიგვერდ',
  'blocks.variant.minimal': 'მინიმალური',
  'blocks.variant.plain': 'მარტივი',
  'blocks.variant.image': 'ფოტოთი',
  'blocks.variant.image-right': 'ფოტო მარჯვნივ',
  'blocks.variant.image-left': 'ფოტო მარცხნივ',
  'blocks.variant.stacked': 'ერთმანეთის ქვეშ',
  'blocks.variant.cards': 'ბარათები',
  'blocks.variant.icons': 'ხატულები',
  'blocks.variant.list': 'სია',
  'blocks.variant.row': 'მწკრივი',
  'blocks.variant.vertical': 'ვერტიკალური',
  'blocks.variant.alternating': 'მონაცვლე',
  'blocks.variant.numbered': 'დანომრილი',
  'blocks.variant.large': 'დიდი',
  'blocks.variant.card': 'ბარათი',
  'blocks.variant.grid': 'ბადე',
  'blocks.variant.carousel': 'კარუსელი',
  'blocks.variant.masonry': 'მოზაიკა',
  'blocks.variant.contained': 'გვერდის შიგნით',
  'blocks.variant.full': 'კიდიდან კიდემდე',
  'blocks.variant.table': 'ცხრილი',
  'blocks.variant.week': 'კვირა',
  'blocks.variant.compact': 'კომპაქტური',
  'blocks.variant.banner': 'ბანერი',
  'blocks.variant.headline': 'დიდი სათაური',
  'blocks.option.narrow': 'ვიწრო',
  'blocks.option.wide': 'ფართო',
  'blocks.option.list': 'სია',
  'blocks.option.cards': 'ბარათები',
  'blocks.option.primary': 'შევსებული',
  'blocks.option.outline': 'კონტურით',
  'blocks.option.sm': 'პატარა',
  'blocks.option.md': 'საშუალო',
  'blocks.option.lg': 'დიდი',
  'blocks.option.xl': 'ძალიან დიდი',
  'blocks.option.line': 'ხაზი',
  'blocks.option.dots': 'წერტილები',
  'blocks.option.accent': 'ბრენდის ზოლი',
  'blocks.PAGE_HEADER.label': 'გვერდის სათაური',
  'blocks.PAGE_HEADER.description': 'შიდა გვერდის სათაური ზემოთ, სურვილისამებრ ფონური ფოტოთი.',
  'blocks.MEDIA_TEXT.label': 'ფოტო და ტექსტი',
  'blocks.MEDIA_TEXT.description': 'ფოტო ან ვიდეო სათაურის, ფორმატირებული ტექსტისა და ღილაკის გვერდით.',
  'blocks.COLUMNS.label': 'სვეტები',
  'blocks.COLUMNS.description': 'ორიდან ოთხ სვეტამდე, თითოეულში ხატულა ან ფოტო, სათაური, ტექსტი და ბმული.',
  'blocks.STATS.label': 'ციფრები',
  'blocks.STATS.description': 'დიდი ციფრები, რომლებიც თქვენს ამბავს ერთი შეხედვით ყვებიან.',
  'blocks.TIMELINE.label': 'ქრონოლოგია',
  'blocks.TIMELINE.description': 'თქვენი ისტორია, წლიდან წლამდე.',
  'blocks.STEPS.label': 'ნაბიჯები',
  'blocks.STEPS.description': 'დანომრილი ინსტრუქცია, მაგალითად როგორ გაწევრიანდეს.',
  'blocks.QUOTE.label': 'ციტატა',
  'blocks.QUOTE.description': 'ერთი დიდი ციტატა ავტორით.',
  'blocks.IMAGE.label': 'ფოტო',
  'blocks.IMAGE.description': 'ერთი ფოტო, გვერდის შიგნით ან კიდიდან კიდემდე, წარწერით.',
  'blocks.VIDEO.label': 'ვიდეო',
  'blocks.VIDEO.description': 'YouTube-ის ან Vimeo-ს ვიდეო, ან ვიდეოფაილი, რომელიც ხმის გარეშე, განმეორებით ითამაშებს.',
  'blocks.LOGOS.label': 'ლოგოები',
  'blocks.LOGOS.description': 'პარტნიორების ან ბრენდების ლოგოების ზოლი.',
  'blocks.SCHEDULE.label': 'განრიგი',
  'blocks.SCHEDULE.description': 'მომდევნო დღეების ვარჯიშები, თქვენი განრიგიდან.',
  'blocks.CAREERS.label': 'კარიერა',
  'blocks.CAREERS.description': 'ღია ვაკანსიები „რეკრუტინგიდან“, თითოეულს განაცხადის ფორმით, სადაც რეზიუმეს ატვირთვა შეიძლება.',
  'blocks.field.privacySlug': 'კონფიდენციალურობის გვერდის მისამართი',
  'blocks.field.privacySlugHint': 'შინაარსის გვერდი, რომელზეც თანხმობის ტექსტი მიუთითებს: /p/ და ეს მისამართი.',
  'blocks.preset.careers.cards': 'კარიერა ორ სვეტად',
  'blocks.OFFER.label': 'შეთავაზება',
  'blocks.OFFER.description': 'მიმდინარე კამპანია, ფასდაკლებითა და თარიღებით.',
  'blocks.RECOGNITION.label': 'გუნდის ჯილდოები',
  'blocks.RECOGNITION.description': 'საჯაროდ მონიშნული ჯილდოები, მაგალითად, თვის ტრენერი. ისინი ტრენერის პირად გვერდზეც გამოჩნდება.',
  'blocks.preset.recognition.list': 'ჯილდოები სიად',
  'blocks.LOCATIONS.label': 'ფილიალები',
  'blocks.LOCATIONS.description': 'ყველა ფილიალი მისამართითა და ტელეფონით.',
  'blocks.HOURS.label': 'სამუშაო საათები',
  'blocks.HOURS.description': 'კვირა დღეების მიხედვით, დარბაზის პარამეტრებიდან.',
  'blocks.SOCIAL.label': 'სოციალური ბმულები',
  'blocks.SOCIAL.description': 'თქვენი სოციალური პროფილები დიდ ღილაკებად.',
  'blocks.BUTTONS.label': 'ღილაკები',
  'blocks.BUTTONS.description': 'ერთიდან ოთხ ღილაკამდე ერთ მწკრივში.',
  'blocks.SPACER.label': 'სივრცე',
  'blocks.SPACER.description': 'ცარიელი ადგილი ორ ბლოკს შორის.',
  'blocks.DIVIDER.label': 'გამყოფი',
  'blocks.DIVIDER.description': 'ხაზი ორ ბლოკს შორის.',
  'blocks.EMBED.label': 'ჩაშენება',
  'blocks.EMBED.description': 'პლეერი ან რუკა YouTube-იდან, Vimeo-დან, Google Maps-იდან, Instagram-იდან ან Facebook-იდან.',
  'blocks.preset.hero.centered': 'მთავარი ბანერი, ცენტრში ლოგოთი',
  'blocks.preset.hero.split': 'მთავარი ბანერი, გვერდიგვერდ',
  'blocks.preset.hero.minimal': 'მთავარი ბანერი, მხოლოდ ტექსტი',
  'blocks.preset.pageHeader.image': 'გვერდის სათაური ფოტოთი',
  'blocks.preset.about.stacked': 'ჩვენ შესახებ, ფოტო ქვემოთ',
  'blocks.preset.mediaText.right': 'ფოტო მარჯვნივ',
  'blocks.preset.columns.cards': 'სვეტები ბარათებად',
  'blocks.preset.facilities.list': 'ინფრასტრუქტურა სიად',
  'blocks.preset.stats.dark': 'ციფრები მუქ ფონზე',
  'blocks.preset.timeline.alternating': 'ქრონოლოგია, მონაცვლე',
  'blocks.preset.steps.cards': 'ნაბიჯები ბარათებად',
  'blocks.preset.quote.card': 'ციტატა ბარათში',
  'blocks.preset.testimonials.carousel': 'შეფასებების კარუსელი',
  'blocks.preset.image.full': 'ფოტო კიდიდან კიდემდე',
  'blocks.preset.gallery.masonry': 'გალერეა, მოზაიკა',
  'blocks.preset.gallery.carousel': 'გალერეის კარუსელი',
  'blocks.preset.video.full': 'ფონური ვიდეო',
  'blocks.preset.plans.table': 'ფასების ცხრილი',
  'blocks.preset.classes.list': 'ვარჯიშები სიად',
  'blocks.preset.schedule.list': 'განრიგი სიად',
  'blocks.preset.trainers.carousel': 'ტრენერების კარუსელი',
  'blocks.preset.trainers.compact': 'გუნდის პორტრეტები',
  'blocks.preset.offer.card': 'შეთავაზების ბარათი',
  'blocks.preset.social.headline': 'დიდი სოციალური სათაური',
  'blocks.preset.cta.split': 'მოწოდება, გვერდიგვერდ',
  'blocks.preset.cta.minimal': 'მოწოდება, მინიმალური',
  'blocks.field.eyebrow': 'პატარა ხაზი სათაურის ზემოთ',
  'blocks.field.eyebrowHint': 'არასავალდებულო, მაგ. დარბაზის სახელი ან ქალაქი.',
  'blocks.field.showLogo': 'ლოგოს ჩვენება',
  'blocks.field.showLogoHint': 'იყენებს ლოგოს „ბრენდინგიდან“.',
  'blocks.field.pageHeaderImageHint': 'ჩანს, როცა იერსახეა „ფოტოთი“.',
  'blocks.field.video': 'ვიდეოს ბმული',
  'blocks.field.videoHint': 'YouTube-ის ან Vimeo-ს ბმული, ან https ბმული MP4 ფაილზე.',
  'blocks.field.columns': 'სვეტები',
  'blocks.field.items': 'ელემენტები',
  'blocks.field.column': 'სვეტი {n}',
  'blocks.field.addColumn': 'სვეტის დამატება',
  'blocks.field.noItems': 'ჯერ არაფერი დამატებულა.',
  'blocks.field.icon': 'ხატულა',
  'blocks.field.noIcon': 'ხატულის გარეშე',
  'blocks.field.number': 'ციფრი {n}',
  'blocks.field.addNumber': 'ციფრის დამატება',
  'blocks.field.value': 'ციფრი',
  'blocks.field.valueHint': '24 სიმბოლომდე, მაგ. 24/7 ან 2000 მ².',
  'blocks.field.milestone': 'ეტაპი {n}',
  'blocks.field.addMilestone': 'ეტაპის დამატება',
  'blocks.field.when': 'როდის',
  'blocks.field.whenHint': 'წელი ან მოკლე თარიღი, მაგ. 1965.',
  'blocks.field.stepItem': 'ნაბიჯი {n}',
  'blocks.field.addStep': 'ნაბიჯის დამატება',
  'blocks.field.role': 'როლი',
  'blocks.field.photo': 'ფოტო',
  'blocks.field.alt': 'აღწერა ეკრანის წამკითხველისთვის',
  'blocks.field.altHint': 'რას აჩვენებს ფოტო, იმ სტუმრებისთვის, ვინც მას ვერ ხედავს.',
  'blocks.field.caption': 'წარწერა',
  'blocks.field.poster': 'სურათი ვიდეოს დაწყებამდე',
  'blocks.field.autoplay': 'თამაში ეკრანზე',
  'blocks.field.autoplayHint': 'უხმოდ ირთვება, სანამ სტუმარს ეკრანზე ჩანს, და ჩერდება, როცა ის გვერდს ჩაუვლის. მუშაობს ვიდეოფაილით, YouTube-ით და Vimeo-ით.',
  'blocks.field.logo': 'ლოგო {n}',
  'blocks.field.addLogo': 'ლოგოს დამატება',
  'blocks.field.name': 'სახელი',
  'blocks.field.days': 'საჩვენებელი დღეები',
  'blocks.field.specialties': 'მხოლოდ ამ სპეციალობის ტრენერები',
  'blocks.field.specialtiesHint': 'დატოვეთ ცარიელი, რომ საიტზე ყველა ტრენერი გამოჩნდეს.',
  'blocks.field.noSpecialties': 'სპეციალობები ჯერ არ არის.',
  'blocks.field.limit': 'მაქსიმუმ',
  'blocks.field.limitHint': 'არასავალდებულო. დატოვეთ ცარიელი, რომ ყველა გამოჩნდეს.',
  'blocks.field.offerFallbackHint': 'გამოიყენება მხოლოდ მაშინ, როცა კამპანია არ მიმდინარეობს.',
  'blocks.field.showWhenNone': 'ჩვენება, როცა კამპანია არ მიმდინარეობს',
  'blocks.field.showWhenNoneHint': 'გამორთვისას ბლოკი კამპანიებს შორის ქრება.',
  'blocks.field.note': 'შენიშვნა',
  'blocks.field.hoursHint': 'თავად საათები მოდის პარამეტრები → სამუშაო საათებიდან.',
  'blocks.field.buttons': 'ღილაკები',
  'blocks.field.buttonItem': 'ღილაკი {n}',
  'blocks.field.addButton': 'ღილაკის დამატება',
  'blocks.field.buttonStyle': 'სტილი',
  'blocks.field.size': 'ზომა',
  'blocks.field.dividerStyle': 'სტილი',
  'blocks.field.embedUrl': 'ჩაშენების ბმული',
  'blocks.field.embedUrlHint': '„Embed“ ბმული YouTube-იდან, Vimeo-დან, Google Maps-იდან, Instagram-იდან ან Facebook-იდან. სხვა საიტები არ მიიღება.',
  'blocks.field.aspect': 'ფორმა',
  'blocks.field.embedTitle': 'სათაური ეკრანის წამკითხველისთვის',
  'blocks.field.embedTitleHint': 'რას აჩვენებს ჩაშენება, მაგ. „რუკა დარბაზამდე“.',
  'website.pages.drag': 'გადაათრიეთ გვერდის {name} გადასატანად',
  'website.pages.untitled': 'უსათაურო გვერდი',
  'website.pages.addTitle': 'გვერდის დამატება',
  'website.pages.addDescription': 'მიეცით სათაური და დაიწყეთ შაბლონიდან. შემდეგ ყველაფრის შეცვლა შეგიძლიათ.',
  'website.pages.titleAddressHint': 'გვერდის მისამართი სათაურიდან იქმნება.',
  'website.pages.create': 'გვერდის შექმნა',
  'website.pages.template': 'დაწყება',
  'website.pages.template.blank': 'ცარიელი',
  'website.pages.template.blank.hint': 'ცარიელი გვერდი.',
  'website.pages.template.landing': 'სარეკლამო გვერდი',
  'website.pages.template.landing.hint': 'მთავარი ბანერი, ციფრები, ფასები, შეფასებები და მოწოდება.',
  'website.pages.template.about': 'ჩვენ შესახებ',
  'website.pages.template.about.hint': 'თქვენი ამბავი, ისტორია, გუნდი და ფოტოები.',
  'website.pages.template.pricing': 'ფასები',
  'website.pages.template.pricing.hint': 'ფასების ცხრილი, მიმდინარე შეთავაზება და კითხვები.',
  'website.pages.template.contact': 'კონტაქტი',
  'website.pages.template.contact.hint': 'საკონტაქტო ფორმა, სამუშაო საათები, ფილიალები და რუკა.',
  'website.pages.template.gallery': 'გალერეა',
  'website.pages.template.gallery.hint': 'ფოტოები და ვიდეო.',
  'website.pages.addressAuto': 'იქმნება სათაურიდან. გვერდის გამოქვეყნების შემდეგ აღარ იცვლება, ასე რომ, მასზე ბმულები არ გაფუჭდება.',
  'website.pages.addressAfterSave': 'სათაურიდან შეიქმნება მონახაზის შენახვისას.',
  'website.pages.addressLocked': 'დააყენა Bulk-მა. სათაურს აღარ მიჰყვება.',
  'website.pages.addressLockedShort': 'მისამართი დააყენა Bulk-მა',
  'website.pages.copyAddress': 'გვერდის ბმულის კოპირება',
  'website.pages.addressCopied': 'ბმული დაკოპირდა',
  'website.pages.addressCopyFailed': 'ბმულის კოპირება ვერ მოხერხდა',
  'website.pages.setAddress': 'მისამართის დაყენება',
  'website.pages.setAddressDescription': 'მისამართს ხელით მხოლოდ Bulk ირჩევს, ჩვეულებრივ იმისთვის, რომ ძველი საიტის ბმული არ გაფუჭდეს.',
  'website.pages.saveBeforeAddress': 'ჯერ შეინახეთ მონახაზი',
  'website.pages.addressFollowTitle': 'კვლავ სათაურს მიჰყვეს',
  'website.pages.addressSet': 'მისამართი შენახულია',
  'website.pages.seo': 'ძებნა და გაზიარება',
  'website.pages.seoTitleHint': 'ჩანს ბრაუზერის ჩანართში და ძიების შედეგებში. დატოვეთ ცარიელი, რომ გვერდის სათაური გამოიყენოს.',
};
